export default "__VITE_ASSET__DhC9b2oM__"